export default __webpack_public_path__ + "images/a49792d8407c9fdbf932a0f5a919d3ee.webp";